"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var object_1 = require("./object");
var description_1 = require("./utils/description");
/**
 * Checks whether a value is a plain object.
 * Plain object is an object of which prototype is Object.prototype or null
 *
 * @example
 * is.plainObject({property: 'value'}); // true
 * is.plainObject(new Object); // true
 * is.plainObject(Object.create(null)); // true
 * is.plainObject(new String('test')); // false
 *
 * const Foo = function() {};
 * is.plainObject(new Foo); // false
 */
function isPlainObject(value) {
    if (!object_1.default(value)) {
        return false;
    }
    var proto = Object.getPrototypeOf(value);
    return proto === Object.prototype || proto === null;
}
description_1.setDescription(isPlainObject, 'a plain object');
exports.default = isPlainObject;
